import { ReactComponent as DashboardIcon } from '@Icons/menu/dashboard.svg';

import BaseNameSideItem from '../../../../../enum/BaseNameSideMenuItem.enum';
import { MenuItem } from '../../../types';
import { createItem } from '../../../utils/createItem';

const DashboardMenuItem: MenuItem = createItem(
  BaseNameSideItem.DASHBOARD,
  BaseNameSideItem.DASHBOARD,
  <DashboardIcon />
);

export default DashboardMenuItem;
